import { Skeleton } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserById } from '@/entities/users';
import { UserForm } from './UserForm';

type Props = {
  userId?: string;
  onSuccess?: () => void;
  onUnsavedChange?: (hasUnsaved: boolean) => void;
};

export const UserCard: FC<Props> = ({ userId, onSuccess, onUnsavedChange }) => {
  const { t } = useTranslation('users');
  const isCreateMode = userId === 'create';
  const id = isCreateMode ? undefined : userId ? Number(userId) : undefined;

  const { data: user, isLoading } = useUserById(id!);

  if (isLoading && id) {
    return <Skeleton className="h-full" />;
  }

  if (user || isCreateMode) {
    return (
      <UserForm key={user?.id ?? 'create'} initial={user} onSuccess={onSuccess} onUnsavedChange={onUnsavedChange} />
    );
  }

  return (
    <div className="flex items-center justify-center h-full text-muted-foreground">
      {t('selectUser', { defaultValue: 'Select a user' })}
    </div>
  );
};
